// Intercom's launcher, hidden while the wide finance modals are open and
// shown again after. Since Studio's Ask AI bubble (2026-10-16) the page
// itself may hide the launcher for good (intercomSettings.hide_default_launcher
// is server-rendered), so "show" restores the page's own setting instead of
// forcing the launcher back. Both also tell the Ask AI bubble to step aside
// for the same modals.
function pageHidesLauncher() {
  return !!(window.intercomSettings && window.intercomSettings.hide_default_launcher)
}

export function hideIntercom() {
  if (window.Intercom) window.Intercom("update", { hide_default_launcher: true })
  window.dispatchEvent(new CustomEvent("studio:launcher-hide"))
}

export function showIntercom() {
  if (window.Intercom) window.Intercom("update", { hide_default_launcher: pageHidesLauncher() })
  window.dispatchEvent(new CustomEvent("studio:launcher-show"))
}
